export type YearsMonthsTranslation = UtilEnglishPluralization | UtilPolishPluralization;

type UtilEnglishPluralization = {
  months_one: string;
  months_other: string;
  years_one: string;
  years_other: string;
};

type UtilPolishPluralization = {
  months_few: string;
  months_many: string;
  months_one: string;
  years_few: string;
  years_many: string;
  years_one: string;
};

export const yearsMonthsTranslation: YearsMonthsTranslation = {
  months_few: '{{count}} miesiące',
  months_many: '{{count}} miesięcy',
  months_one: '{{count}} miesiąc',
  years_few: '{{count}} lata',
  years_many: '{{count}} lat',
  years_one: '{{count}} rok',
};
